const Config = {
  encrypt_key:"#@PWD!!"
}

export default Config;